import React from 'react';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import { Modal, Button } from 'antd';

interface modalDSProps{
  closeModal: any,
  modalState: any,
  sendData: any,
  intl: any
}

function ModalDS({ closeModal, modalState, sendData, intl }:modalDSProps) {
  return (
    <Modal
      className="patient-modalDontSign"
      visible={modalState}
      width={620}
      footer={null}
      closable={false}
    >
      <div className="fullModal">
        <div className="modalTop">
          <span style={{ fontSize: 22, color: '#F28100' }}><FontAwesomeIcon icon={faExclamationCircle} /></span>
          <h3 style={{ marginLeft: 16 }}>{intl.formatMessage({ id: 'pacientes.new_client.law_must_sign' })}</h3>
        </div>
        <div className="bodyModal">
          <p>{intl.formatMessage({ id: 'pacientes.new_client.if_dont' })}</p>
        </div>
        <div className="buttonBar">
          <Button onClick={closeModal} className="buttonCancel">
            {intl.formatMessage({ id: 'pacientes.new_client.cancel' })}
          </Button>
          <div className="rightButtons">
            <Button 
              className="withoutRGPD"
              onClick={() => {
                sendData(false);
                closeModal();
                }}>
              {intl.formatMessage({ id: 'pacientes.new_client.create_wo_sign' })}
            </Button>
            <Button
              className="nowRGPD"
              type="primary"
              style={{ marginLeft: '8px' }}
              onClick={() => {
                sendData(true);
                closeModal();
                }}>
              {intl.formatMessage({ id: 'pacientes.new_client.sign_now' })}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default injectIntl(ModalDS);
